import React from 'react';

const FieldError = ({text}) => (
	<div className="field-error">{text}</div>
);

export default FieldError;



// WEBPACK FOOTER //
// ./src/components/FieldError/index.js